export default "/bg/sm/sea4.jpg"